import React, { FC } from 'react';
import styles from './UnavailableAlert.scss';

type UnavailableAlertProps = {
  officeName: string;
};

export const UnavailableAlert: FC<UnavailableAlertProps> = ({ officeName }) => {
  return (
    <div className={styles.alert}>
      <h1>
        源泉徴収票が提出できない場合、<span className={styles.officeName}>{officeName}</span>で<br />
        年末調整ができません。
      </h1>
      <p>
        自身で確定申告をしてください。 会社への原本（保険料控除や住宅ローン控除などの証明書）提出は不要です。
        「扶養控除等（異動）申告書」はジョブカン年末調整で作成するので、「次へ」を押して最後まで回答してください
      </p>
    </div>
  );
};
